import { Box, Paper } from "@mui/material";
import { DataGrid, type GridCellParams, type GridColDef } from "@mui/x-data-grid";
import type React from "react";
import { useCallback, useState } from "react";
import { useAuth } from "@/features/auth";
import type { AdminListData } from "@/shared/types";
import { EditAdminsUserDialog } from "./EditAdminUserDialog";

const COLUMNS: GridColDef[] = [
	{ field: "email", headerName: "メールアドレス", flex: 2 },
	{ field: "usergroup", headerName: "権限", flex: 2 },
	{ field: "department", headerName: "所属", flex: 3 },
];
export interface AdminListProps {
	userList: AdminListData[];
	loading: boolean;
	onEditUser: () => void | Promise<void>;
}

export function AdminsList({ userList, loading, onEditUser }: AdminListProps): React.ReactElement {
	const { usergroup } = useAuth();
	const [openEdit, setOpenEdit] = useState(false);
	const [selectedUser, setSelectedUser] = useState<AdminListData | null>(null);

	const handleCellClick = useCallback(
		(params: GridCellParams) => {
			if (params.field === "email") {
				if (usergroup !== "管理者") return;
				const rowData = params.row as AdminListData;
				setSelectedUser(rowData);
				setOpenEdit(true);
			}
		},
		[usergroup],
	);

	return (
		<Box sx={{ mb: 4 }}>
			<Paper>
				<DataGrid
					loading={loading}
					rows={userList}
					columns={COLUMNS}
					pageSizeOptions={[10, 20]}
					initialState={{
						pagination: {
							paginationModel: { page: 0, pageSize: 10 },
						},
					}}
					sx={{
						border: 0,
						"& .MuiDataGrid-columnHeaders": {
							backgroundColor: "#F3E9F0",
						},
						"& .MuiDataGrid-cell[data-field='email']": {
							backgroundColor: "#FEF1FA",
						},
						"& .MuiDataGrid-cell[data-field='department']": {
							backgroundColor: "#FEF1FA",
						},
					}}
					onCellClick={handleCellClick}
				/>
			</Paper>

			{selectedUser && (
				<EditAdminsUserDialog
					open={openEdit}
					handleClose={() => setOpenEdit(false)}
					initialData={{
						email: selectedUser.email,
						department: selectedUser.department,
						role: selectedUser.usergroup,
					}}
					onEditUser={onEditUser}
				/>
			)}
		</Box>
	);
}
